export enum ColorCode {
  None = 536870911,
  Gray = 8421504,
  Green = 32768,
  Red = 255,
  Blue = 16711680,
  Yellow = 642815,
  Purple = 8388736,
}
